var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMsWord = function SvgMsWord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 3a2 2 0 0 0-.4.043l-.002-.002L4.66 5.029l-.031.006-.002.002A2 2 0 0 0 3 7v16a2 2 0 0 0 1.629 1.965l9.96 1.992.009.002A2 2 0 0 0 15 27a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm4 2v3h4a1 1 0 0 1 0 2h-4v2h4a1 1 0 0 1 0 2h-4v2h4a1 1 0 0 1 0 2h-4v2h4a1 1 0 0 1 0 2h-4v3h6a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-6zM5.264 10h1.859l.94 6.633h.087L9.277 10h1.436l1.168 6.633h.088L12.89 10h1.845l-1.84 10h-1.68l-1.177-6.127h-.088L8.795 20H7.104l-1.84-10z"
  })));
};
export default SvgMsWord;